export const AUTOMATED_TYPE_FIELD_NAME = 'automatedType';
export const DELAY = 0.2;
